export const ignore = "cab";
export default {ignore};